import React from "react";

export function Footer(ts) {
  const { i18n } = ts;
  const texto = i18n['t']
  const obj = i18n['i18n']

  return (
    <>
      <div className="bg-gray-100 pt-5">
        <div className="max-w-screen-lg px-4 sm:px-6 text-gray-800 sm:grid md:grid-cols-4 sm:grid-cols-2 mx-auto">
          {/* <div className="p-5">
            <h3 className="font-bold text-xl text-sky-500"></h3>
            <a className="my-3 block"  target="_blank" href="/media/pdf/Willian.pdf" download>
              RESUME
            </a>
          </div> */}

          <div className="p-5">
            <div className="text-sm uppercase text-sky-500 font-bold">Willian Buqui</div>
            <a className="my-3 block" target="_blank" href="/media/pdf/Willian.pdf" download>
              
              {texto('footer_4')}
            </a>
          </div>
          <div className="p-5">
            <div className="text-sm uppercase text-sky-500 font-bold">{texto('footer_1')}</div>
            <a className="my-3 block" target="_blank"
              href="https://github.com/cryty13">
              GitHub
            </a>
          </div>
          <div className="p-5">
            <div className="text-sm uppercase text-sky-500 font-bold">{texto('footer_2')}</div>
            <a className="my-3 block" target="_blank"
              href="https://pt-br.reactjs.org/tutorial/tutorial.html" >
              React
            </a>
            <a className="my-3 block" target="_blank"
              href="https://tailwindcss.com/docs/installation">
              Tailwind
            </a>
          </div>
          <div className="p-5">
            <div className="text-sm uppercase text-sky-500 font-bold">{texto('footer_3')}</div>
            <a className="my-3 block" >
              willian.buqui@gmail.com
            </a>
            {/* <a className="my-3 block" >
              +55 11 99847-4779
            </a> */}
          </div>
        </div>
      </div>

      <div className="bg-gray-100 pt-2">
        <div className="flex pb-5 px-3 m-auto pt-5 border-t text-gray-800 text-sm flex-col max-w-screen-lg items-center">
          <div className="my-1"> {texto('footer_5')} Willian Buqui © 2023 Willian Buqui {texto('footer_6')}</div>
        </div>
      </div>



    </>
  );


}
